import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown",
  "use": "icon-dropdown-usage",
  "viewBox": "0 0 14 7",
  "content": "<symbol viewBox=\"0 0 14 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dropdown\">\r\n<path d=\"M12.28 0.966614L7.93338 5.31331C7.42005 5.82665 6.58004 5.82665 6.06671 5.31331L1.72003 0.966614\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol